<template lang="html">
  <div class="wrapper" :style="{ 'background-image': 'url(' + dataSurvey.client.background + ')', 'background-color': '#EEEEEE' } " v-if="dataSurvey">
    
    <div class="bg text-center">
      <div class="container-fluid" style="height: 85%;">
        <img :src="dataSurvey.client.logo" alt="Logo de la compañia" class="logo">
        <div class="row justify-content-center">
          <div class="col-12 col-md-11 text-center">
            <b-row v-if="!completed">
              <nps
                v-if="currentStep.type === 'NPS'"
                :question="changeTitleTags(currentStep, dataSurvey.contact)"
                :default-value="score"
                @change-step="getNextStep"
              ></nps>              
              <smiley
                v-if="currentStep.type === 'SMILEY'"
                :question="changeTitleTags(currentStep, dataSurvey.contact)"
                :order ="'right'"
                @change-step="getNextStep"
              ></smiley>
              <radio
                v-if="currentStep.type === 'RADIO'"
                :question="changeTitleTags(currentStep, dataSurvey.contact)"
                :default-value="score"
                @change-step="getNextStep"
              ></radio>
              <simple-text
                v-if="currentStep.type === 'TEXT'"
                :question="changeTitleTags(currentStep, dataSurvey.contact)"
                @change-step="getNextStep"
              ></simple-text>
              <numeral
                v-if="currentStep.type === 'NUMERAL'"
                :question="changeTitleTags(currentStep, dataSurvey.contact)"
                :default-value="score"
                @change-step="getNextStep"
              ></numeral>
              <list
                v-if="currentStep.type === 'LIST'"
                :question="changeTitleTags(currentStep, dataSurvey.contact)"
                @change-step="getNextStep"
              ></list>
              <check
                v-if="currentStep.type === 'CHECK'"
                :question="changeTitleTags(currentStep, dataSurvey.contact)"
                @change-step="getNextStep"
              ></check>
            </b-row>

            <b-row v-if="!completed">
                <b-col class="center-buttom-footer" align-self="start">
                   <!--
                  <v-btn outline @click = "changeStep(-1)" v-if="activeStep != 0" :style="{ color:dataSurvey.client.color }"> 
                    <i class="material-icons">
                      arrow_back
                    </i>
                  </v-btn> -->
                </b-col>
               
                <b-col class="center-buttom-footer" align-self="end">
                  <v-btn outline @click="sendData" :disabled="validate" :style="{ color:dataSurvey.client.color }" class="btn-sgt">
                    <i class="material-icons">
                      arrow_forward
                    </i>
                  </v-btn>
                </b-col>
               
              </b-row> 
              
              <div class="text-center" v-if="completed">
                <h2 v-html="dataSurvey.survey.message_success ? dataSurvey.survey.message_success : 'Encuesta contestada satisfactoriamente.'"></h2>
                <h3 v-html="dataSurvey.survey.message_sub ? dataSurvey.survey.message_sub : '¡Muchas gracias por tu tiempo, estamos en confianza!'"></h3>
              </div>
          </div>
        </div>

        <div>
          <a :href="defaultWeb" target="_blank" :hidden="hiddenLogo">
              <img :src="defaultLogo" alt="Logo" class="branding">
          </a>
        </div>

      </div>
      
    </div>
    
  </div>
</template>

<script>
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './sass/survey.css';
import axios from 'axios';
import SimpleText from './components/SimpleText.vue';
import Radio from './components/Radio.vue';
import Check from './components/Check.vue';
import Nps from './components/Nps.vue';
import Numeral from './components/Numeral.vue';
import Smiley from './components/Smiley.vue';
import { mapGetters } from 'vuex';
import List from './components/List.vue';

Vue.use(BootstrapVue);

export default {
  
  components: {
    SimpleText,
    Radio,
    Check,
    Nps,
    Numeral,
    Smiley,
    List
  },
  props: {
    dataSurvey: {
      type: Object,
      required: true
    }
  },
  data: () => {
    return {
      completed: false,
      activeStep: 0,
      previustQuestionId: null,
      previusQuestionIdAux: null,
      nextQuestionId: null,
      score: null,
      defaultLogo: process.env.LOGO_PATH,
      defaultWeb: process.env.URL_WEB
    };
  },
  computed: {
    currentStep: function () {
      return this.dataSurvey.survey.steps[this.activeStep];  
    },
    currentQuestions: function () {
      return this.currentStep.questions; 
    },
    validate: function () {
      if (this.currentStep.type === 'NPS' || this.currentStep.type === 'NUMERAL' || this.currentStep.type === 'SMILEY' || this.currentStep.type === 'LIST') {
        return this.currentStep.value === null;
      }
      if (this.currentStep.type === 'CHECK' && this.currentStep.options_values.length === 0) {
        return true;
      }
      return false;
    },
    hiddenLogo: function () {
      if (this.dataSurvey.client.hidden_logo_knower) {
        return true;
      }
      return false;
    },
  },
  created: function () {
    this.score = this.$route.params.score;
  },
  methods: {
    getNextStep (values) {
      this.nextQuestionId = values.nextQuestionId;
      /* only change previus if click in next */
      this.previusQuestionIdAux = values.previusQuestionId;

      /* Case of first question with value */
      if (typeof this.score !== 'undefined' && this.score !== null && this.activeStep === 0) {
        this.sendData();
      }
      this.score = null;
    },
    changeStep () {
      this.previustQuestionId = this.previusQuestionIdAux;

      if (this.nextQuestionId == null) {
        this.completed = true;
      }
      this.dataSurvey.survey.steps.forEach((step, index) => {
        if (step.id === this.nextQuestionId) {
          this.activeStep = index;
          this.completed = false;
        }
      });
    },
    sendData () {

      let url = 'v2/survey/store';
      const payload = {
        survey_id: this.dataSurvey.survey.id,
        question: {
          'id': this.currentStep.id,
          'value': this.currentStep.value,
          'options_values': this.currentStep.options_values,
          'type': this.currentStep.type
        },
        round_id: this.dataSurvey.survey.round_id,
        contact_id: this.dataSurvey.contact.id,
        email_id: this.dataSurvey.contact.email_id,
      };
      
      this.changeStep();

      if (!this.dataSurvey.contact.test) {
        axios.post(url, payload).then(response => {
        }).catch(error => {
        });
      }
    },
    checkIndex () {
      if (!this.data.completed) {
        if (this.steps[0].questions[0].type === 'NPS' && this.score) {
          this.steps[0].questions[0].value = this.score;
          this.sendData();
        }
        if (this.steps[0].questions[0].type === 'RADIO' && this.score) {
          this.steps[0].questions[0].options_values[0] = this.score;
          this.sendData();
        }
        if (this.steps[0].questions[0].type === 'NUMERAL' && this.score) {
          this.steps[0].questions[0].value = this.score;
          this.sendData();
        }
      }
    
      for (let index = 0; index < this.steps.length; index++) {
        for (let key = 0; key < this.steps[index]['questions'].length; key++) {
          if (this.steps[index]['questions'][key]['value'] === null) {
            if (this.steps[index]['questions'][key]['type'] === 'CHECK' || this.steps[index]['questions'][key]['type'] === 'RADIO') {
              if (this.steps[index]['questions'][key]['options_values'].length === 0) {
                this.active_step = index;
                return index;
              }
            } else {
              this.active_step = index;
              return index;
            }
          }
      
        }
      }
    },
    changeTitleTags (question, contact) {
      let title = question.title;
      if (!contact.test) {     
        title = title.replace('##segmentation1##', contact.segmentation);
        title = title.replace('##segmentation##', contact.segmentation);
        title = title.replace('##segmentation2##', contact.segmentation2);
        title = title.replace('##tag##', contact.tag);
        title = title.replace('##company##', contact.company);
        title = title.replace('##seniority##', contact.seniority);
        title = title.replace('##name##', contact.name);
        title = title.replace('##country##', contact.country);      
        title = title.replace('##position##', contact.position);
        title = title.replace('##priority##', contact.priority);
      }
      question.title = title;
      
      return question;
    }

  }
};
</script>

<style>
.center-buttom-footer {
    top: 50% !important;
    transform: translateY(85%) !important;
}
.progress-bar-top{
  background-color: white;
  margin-top: -20px;
}
.btn-sgt{
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/surveys/v2/SurveyMailing.vue